<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_11"></a><a id="part1"></a>Part One</h2>
<h2 class="h2a">Klein on Husserl’s Phenomenology and the History of Science<a id="page_12"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?2cc6b9c2